import { render } from "./qa.html?vue&type=template&id=709b5ad2"
import script from "./Qa.vue?vue&type=script&lang=ts"
export * from "./Qa.vue?vue&type=script&lang=ts"

import "./qa.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script